require('./mortgageRequestMortgageEditView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const mortgageRequestMortgageDataActions = require('actions/mortgageRequest/mortgageRequestMortgageData');
const mortgageRequestConditionsDataActions = require('actions/mortgageRequest/mortgageRequestConditions');
const mortgageRequestInsurancesRelatedActions = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');

// @ components
const { MortgageRequestMortgageEditForm } = require('components/mortgageRequest/mortgageRequestMortgageEditForm/mortgageRequestMortgageEditForm');
const { okInsuranceActions: { insuranceRequestRelatedState } } = require('ok-insurance');

class MortgageRequestMortgageEditView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const {
            requestMortgageExtraData,
            requestMortgageFeeReset,
            requestMortgageConditions,
            requestInsuranceState,
            requestMortgageInsuranceConfig,
            flagBasedFeatures,
            immMortgageRequestState
        } = this.props;

        requestMortgageFeeReset();
        requestMortgageExtraData();
        requestMortgageConditions();
        requestMortgageInsuranceConfig();

        if (flagBasedFeatures.get('mortgage-home-insurance-enabled', false)) {
            requestInsuranceState(false, immMortgageRequestState.get('idExpediente')).then(() => {
                const { insuranceState, requestMortgageInsuranceExpedient } = this.props;
                if (insuranceState.getIn(['data', 'id'])) {
                    requestMortgageInsuranceExpedient(insuranceState.getIn(['data', 'id']));
                }
            });
        }
    }

    render() {
        const {
            mortgageDataState,
            mortgageExtraDataState,
            mortgageRequestConditions,
            mortgageInsuranceState,
            insuranceState,
            immGlobalPosition
        } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestMortgageEdit-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
        const isFetchedDataState = mortgageDataState.get('req');
        const isFetchedExtraDataState = mortgageExtraDataState.get('req');
        const isFetchingDataState = mortgageDataState.get('isFetching');
        const isFetchingExtraDataState = mortgageExtraDataState.get('isFetching');
        const isFetchingConditions = mortgageRequestConditions.get('isFetching');
        const isFetchingInsuranceState = insuranceState.get('isFetching');
        const isFetchingInsuranceExpedient = mortgageInsuranceState.get('isFetchingInsurancesStatus');
        const isFetchingInsuranceConfig = mortgageInsuranceState.get('isFetchingConfig');

        if (
            !isFetchedDataState ||
            !isFetchedExtraDataState ||
            isFetchingDataState ||
            isFetchingExtraDataState ||
            isFetchingConditions ||
            isFetchingInsuranceState ||
            isFetchingInsuranceExpedient ||
            isFetchingInsuranceConfig
        ) {
            return (
                <div className="row step-item">
                    <LoadingSection />
                </div>
            );
        }

        return (
            <div className="mortgage-request-mortgage-edit-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestManager-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <MortgageRequestMortgageEditForm />
            </div>
        );
    }
}

MortgageRequestMortgageEditView.propTypes = {
    mortgageDataState: PropTypes.object,
    mortgageExtraDataState: PropTypes.object,
    mortgageRequestConditions: PropTypes.object,
    insuranceState: PropTypes.object,
    mortgageInsuranceState: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    requestMortgageExtraData: PropTypes.func,
    requestMortgageFeeReset: PropTypes.func,
    requestMortgageConditions: PropTypes.func,
    requestInsuranceState: PropTypes.func,
    requestMortgageInsuranceExpedient: PropTypes.func,
    requestMortgageInsuranceConfig: PropTypes.func,
    immGlobalPosition: PropTypes.object.isRequired,
    immMortgageRequestState: PropTypes.object
};

module.exports.constructor = MortgageRequestMortgageEditView;
module.exports.MortgageRequestMortgageEditView = connect(
    state => ({
        mortgageDataState: state.mortgageRequestMortgageData,
        mortgageExtraDataState: state.mortgageRequestMortgageExtraData,
        mortgageRequestConditions: state.mortgageRequestConditions,
        insuranceState: state.insuranceRequestRelatedState,
        mortgageInsuranceState: state.mortgageRequestManagerInsuranceRelated,
        flagBasedFeatures: state.flagBasedFeatures,
        immMortgageRequestState: state.mortgageRequestState,
        immGlobalPosition: state.globalPosition,
    }),
    {
        requestMortgageExtraData: mortgageRequestMortgageDataActions.requestMortgageExtraData,
        requestMortgageFeeReset: mortgageRequestMortgageDataActions.requestMortgageFeeReset,
        requestMortgageConditions: mortgageRequestConditionsDataActions.requestConditions,
        requestInsuranceState: insuranceRequestRelatedState.requestInsuranceRelatedCurrentState,
        requestMortgageInsuranceExpedient: mortgageRequestInsurancesRelatedActions.mortgageRequestInsurancesRelatedStatusData,
        requestMortgageInsuranceConfig: mortgageRequestInsurancesRelatedActions.requestInsuranceRelatedConfig
    })(MortgageRequestMortgageEditView);
